<template>
  <v-list-item v-if="!isEditing" avatar ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-bed'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">希望の滞在方法</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">希望の滞在方法</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getStayLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>滞在方法</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">滞在方法の選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.stays.content">
          <v-chip
            v-for="item in getStayItems"
            :key="`stays_content_${item.value}`"
            :value="item.value"
            :rules="rules.stays">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.stays.note"
          label="希望滞在先の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyStays',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        stays: {
          dorm: '寮',
          homestay: 'ホームステイ',
          relatives: '知人宅',
          apartment: 'アパート',
          others: 'その他'
        }
      },
      form: {
        stays: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        stays: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.stays
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.stays.content && this.$props.data.stays.content === 'NONE'))
        this.$set(this.form, 'stays', {
          id: '' + (this.$props.data.stays.id ? this.$props.data.stays.id : 'new_stays'),
          content: this.$props.data.stays.content ? this.$props.data.stays.content.split(',') : [],
          note: this.$props.data.stays.note ? this.$props.data.stays.note : ''
        })
      } else {
        this.$set(this.form, 'stays', {
          id: 'new_stays',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'stays'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.stays, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['stays', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'stays'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['stays', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'stays'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.stays &&
        this.$props.data.stays.content &&
        this.$props.data.stays.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.stays &&
        this.$props.data.stays.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.stays &&
        this.$props.data.stays.note
      ) ? this.$props.data.stays.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.stays &&
        this.$props.data.stays.note
      )
    },
    getStayItems () {
      return Object.keys(this.meta.stays).map(key => {
        return {
          text: this.meta.stays[key],
          value: key
        }
      })
    },
    getStayLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.stays &&
        this.$props.data.stays.content
      ) ? this.$props.data.stays.content.split(',').map(key => {
          return (this.meta.stays[key]) ? this.meta.stays[key] : ''
        }) : []
    }
  }
}
</script>
